import { render, staticRenderFns } from "./ProfileAddresses.vue?vue&type=template&id=56c75dad&"
import script from "./ProfileAddresses.vue?vue&type=script&lang=js&"
export * from "./ProfileAddresses.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAddresses.vue?vue&type=style&index=0&id=56c75dad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports